const HomeConstants = {
    HOME_OPEN_SIDEBAR: 'HOME_OPEN_SIDEBAR',
    HOME_CLOSE_SIDEBAR: 'HOME_CLOSE_SIDEBAR',
    HOME_SELECTED_MENU: 'HOME_SELECTED_MENU',
    HOME_PAGE_LOADING: 'HOME_PAGE_LOADING',
    // Namespaced to avoid collision with facility/stores/FacilityStore
    HOME_FACILITY_GET_ALL: 'HOME_FACILITY_GET_ALL',
    HOME_KB_GET_RECENT: 'HOME_KB_GET_RECENT',
    HOME_KB_GET_FAVORITES: 'HOME_KB_GET_FAVORITES',
} as const;

export default HomeConstants;
